export default function initNegativeBanner() {
  const negativeBanner = document.querySelector(".negative-banner");
  const breadcrumb = document.querySelector(".page-breadcrumb");
  const header = document.querySelector(".navbar-wrapper");

  if (!negativeBanner) return;

  function updateBannerPadding() {
    if (header) {
      const headerHeight = header.offsetHeight;
      const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 0;
      const totalHeight = breadcrumbHeight + headerHeight;

      // Set negative margin-top for negative-banner
      negativeBanner.style.marginTop = `-${headerHeight}px`;
      negativeBanner.style.paddingTop = `${totalHeight}px`;
    } else {
      negativeBanner.style.marginTop = "";
      negativeBanner.style.paddingTop = "";
    }
  }

  // Initial call
  updateBannerPadding();

  // Update on resize
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      updateBannerPadding();
    }, 150);
  });
}
